import { z } from 'zod';
import i18n from '../../../lib/i18n';

const requiredFieldMessage = i18n.t('RequiredFieldMessage');
const invalidPhoneMessage = 'Informe um telefone válido.';
const invalidInformation = 'Informação inválida.';
const invalidEmailMessage = 'Informe um email válido.';

const addCustomIssue = (
    ctx: z.RefinementCtx,
    path: string,
    message: string,
) => {
    ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: [path],
        message,
    });
};

const addCustomIssueWithoutPath = (ctx: z.RefinementCtx, message: string) => {
    ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message,
    });
};

const checkIsValidPhone = (phone: string, ctx: any, path?: string) => {
    const validPhone = phone.replace(/\D/g, '');
    if (validPhone.length !== 10 && validPhone.length !== 11) {
        path
            ? addCustomIssue(ctx, path, invalidPhoneMessage)
            : addCustomIssueWithoutPath(ctx, invalidPhoneMessage);
    }
};

const defaultMessages = {
    invalid_type_error: invalidInformation,
    required_error: requiredFieldMessage,
};

const requiredString = () => {
    return z.string(defaultMessages).min(1, requiredFieldMessage);
};

const requiredPhone = () => {
    return z
        .string(defaultMessages)
        .min(1, requiredFieldMessage)
        .superRefine((data: any, ctx: any) => {
            checkIsValidPhone(data, ctx);
        });
};

const contactValidationSchema = (isContactRequired = true) =>
    isContactRequired
        ? z.object({
              responsible: requiredString(),
              occupation: requiredString(),
              phone: requiredPhone(),
              email: requiredString().email(invalidEmailMessage),
          })
        : z.object({});

const ValidationContactFormService = {
    checkIsValidPhone,
    contactValidationSchema,
};

export default ValidationContactFormService;
